export{default as newsfeedCard} from './newsfeedCard'
export{default as newsfeedlist} from './newsfeedlist'